/**
 * Get the start of the UTC day for a given timestamp
 */
const getStartOfUTCDay = (timestamp: number) => new Date(timestamp).setUTCHours(0, 0, 0, 0);

/**
 * Get the number of days left in the trial
 * @deprecated use `entitlementInfo.subscription.trial.timeLeft` to derive days left
 */
export const getTrialDaysLeft = (
	currentDate: number,
	trialEndTime?: number | null,
): number | undefined =>
	trialEndTime
		? Math.ceil((getStartOfUTCDay(trialEndTime) - currentDate) / (24 * 3600 * 1000))
		: undefined;
